import styled from "styled-components";
import { Colors } from "src/styles/DesignSystem";

export const MapsContainer = styled.section`
    width: 100%;
    background-color: ${Colors.lighBrown};
    padding: 0 5rem 10rem 5rem;
    margin-top: 15%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    /* align-items: center; */    

    header{
        margin-top: 5%;
        margin-left: -8%;

        h1{
            &::before{
                width: 150px;
                right: -55%;
                top: 365%;
            }
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        padding: 5rem 3rem 10rem 3rem;

        header{
            margin-left: -30%;

            h1{
                font-size: 1.5rem;

                &::before{
                    right: -55%;
                    top: 350%;
                }
            }
        }
    }
`;

export const MapWrapper = styled.aside`
    width: 75%;
    margin: -10% auto 0 auto;
    border-radius:25px;
    /* background-color: rgba(207, 98, 24, 0.842); */

    &>div{
        width: 100%;
        height: 400px;
        border-radius:25px;
        /* mix-blend-mode:  soft-light; */
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        width: 100%;
        margin-top: -15%;
    }
`;

export const InfosWrapper = styled.section`
    width: 75%;
    margin: 0 auto;

    display: flex;
    justify-content: space-evenly;
`;

export const MapInfo = styled.aside`
    /* width: 400px; */
    padding: 1rem;
    border-radius: 25px;

    color: ${Colors.grey};

    h3{
        font-family: 'Filson Regular', Arial, sans-serif;
        font-size: .9rem;
        line-height: 2rem;
    }

    span{
        font-family: 'Filson Heavy', Arial, sans-serif;
        font-size: .9rem;
        line-height: 1rem;
    }

    @media screen and (min-width: 320px) and (max-width: 480px){
        bottom: 5%;
        left: 2.5%;

        h3{
            font-size: .8rem;
        }

        span{
            font-size: 1rem;
        }
    }
`;